import m from 'mithril';

import { Type } from '../components/Typography';
import notFoundImage from '../assets/images/404.svg';

/**
 * Not found page.
 */
export const NotFound: m.Component = {
  view: () => {
    return m('section', { class: 'not-found-page' }, [
      m('div', { class: 'not-found-page__image-wrap' }, [
        m('img', {
          src: notFoundImage,
          alt: 'Error 404',
        }),
      ]),
      m('div', { class: 'not-found-page__body' }, [
        m(Type, { size: 'title' }, 'Uh oh!'),
        m(Type, { size: 'heading' }, "We can't find the page you're looking for."),
        m(Type, { size: 'heading' }, 'The links below should help.'),
      ]),
    ]);
  },
};
